// extracted by mini-css-extract-plugin
export default {"tabContainer":"GadgetDetailsSection_tabContainer__TMAjq"};